import React from 'react';
import { FadeIn } from './FadeIn';
import { Check, ShieldCheck, ArrowRight, Trophy, Star, Lock, Clock, CreditCard, Zap } from 'lucide-react';
import { motion } from 'framer-motion';
export function OfferSection() {
  return <section id="comprar" className="px-4 max-w-5xl mx-auto pt-[1px] pb-[1px]" data-id="element-96">
      {/* Urgency Bar */}
      <FadeIn className="mb-8 -mt-8" data-id="element-97">
        <motion.div className="max-w-md mx-auto bg-mint/20 border-2 border-mint rounded-full px-6 py-3 flex items-center justify-center gap-3 shadow-lg shadow-mint/15" animate={{
        boxShadow: ['0 0 15px rgba(152,224,186,0.15)', '0 0 25px rgba(152,224,186,0.3)', '0 0 15px rgba(152,224,186,0.15)']
      }} transition={{
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-98">
          <div className="relative shrink-0" data-id="element-99">
            <span className="absolute -top-0.5 -right-0.5 w-2.5 h-2.5 bg-mint rounded-full animate-ping" data-id="element-100" />
            <span className="absolute -top-0.5 -right-0.5 w-2.5 h-2.5 bg-mint rounded-full" data-id="element-101" />
            <Clock size={18} className="text-mint" data-id="element-102" />
          </div>
          <div className="flex-1" data-id="element-103">
            <div className="flex items-center justify-between mb-1" data-id="element-104">
              <span className="text-mint text-sm font-bold" data-id="element-105">
                🔥 68% de los cupos tomados
              </span>
            </div>
            <div className="w-full bg-black/30 rounded-full h-2.5" data-id="element-106">
              <motion.div className="bg-gradient-to-r from-mint to-emerald-400 h-2.5 rounded-full" initial={{
              width: 0
            }} whileInView={{
              width: '68%'
            }} transition={{
              duration: 1.2,
              ease: 'easeOut'
            }} viewport={{
              once: true
            }} data-id="element-107" />
            </div>
          </div>
        </motion.div>
      </FadeIn>

      <FadeIn className="text-center mb-8" data-id="element-108">
        <h2 className="text-3xl md:text-5xl text-mint mb-4 uppercase font-['Open_Sans',_sans-serif] font-[900]" data-id="element-109">
          <span className="text-white" data-id="element-110">Elegí tu</span> MegaPack Nutripro Listo
        </h2>
        <p className="text-lg md:text-xl text-white/70 font-medium" data-id="element-111">
          Las dos opciones incluyen los 5 tomos estratégicos completos
        </p>
      </FadeIn>

      {/* Pricing Cards */}
      <div className="grid md:grid-cols-2 gap-8 mb-8" data-id="element-112">
        {/* Plan 1: Standard */}
        <FadeIn delay={0.1} className="bg-surface border border-mint/20 rounded-3xl p-8 flex flex-col relative" data-id="element-113">
          <div className="mb-4" data-id="element-114">
            <h3 className="text-white mb-2 text-[20px] font-[900] font-['Open_Sans',_sans-serif] uppercase" data-id="element-115">
              🥕 Megapack Nutripro Listo
            </h3>
            <p className="text-white/50 text-sm font-medium" data-id="element-116">
              5 tomos + 3 bonos
            </p>
          </div>

          <div className="mb-6" data-id="element-117">
            <p className="text-white/40 line-through text-lg mb-1" data-id="element-118">$34.990</p>
            <p className="text-5xl font-[900] text-white font-['Open_Sans',_sans-serif]" data-id="element-119">
              $19.990
              <span className="text-base text-white/40 font-normal ml-2" data-id="element-120">
                ARS
              </span>
            </p>
          </div>

          <a href="https://salud-en-tu-plato.myshopify.com/checkouts/cn/hWNAwTkYc0jPVzOcWmb07wSg/es-ar?_r=AQABOh3_y5o0n906Mqws4ivAq5RkQJOK5cqOLDDedCXRGTQ&cart_link_id=1TztK5e8&preview_theme_id=151828791463" target="_blank" rel="noopener noreferrer" className="w-full block text-center bg-white/10 hover:bg-white/15 text-white font-bold py-4 rounded-xl transition-colors border border-white/10" data-id="element-121">
            QUIERO EL MEGAPACK
          </a>
        </FadeIn>

        {/* Plan 2: Plus (Highlighted) */}
        <FadeIn delay={0.2} className="bg-surface border-2 border-mint rounded-3xl p-8 flex flex-col relative transform md:-translate-y-4 shadow-2xl shadow-mint/10" data-id="element-122">
          {/* Badge */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-mint text-black font-bold px-5 py-1.5 rounded-full text-sm flex items-center gap-1.5" data-id="element-123">
            <Star size={14} fill="currentColor" data-id="element-124" /> MÁS ELEGIDO
          </div>

          <div className="mb-4 mt-2" data-id="element-125">
            <h3 className="text-mint mb-2 text-[20px] font-[900] font-['Open_Sans',_sans-serif] uppercase" data-id="element-126">
              🚀Megapack + Nutripro Plus
            </h3>
            <p className="text-white/50 text-sm font-medium" data-id="element-127">
              5 tomos + 3 bonos + NUTRIPRO PLUS (gestión, marketing, precios y
              negocio)
            </p>
          </div>

          {/* Savings badge */}
          <div className="inline-flex self-start items-center gap-1.5 bg-mint/15 border border-mint/30 text-mint text-xs font-bold px-3 py-1.5 rounded-full mb-4" data-id="element-128">
            <Trophy size={14} data-id="element-129" /> AHORRÁS $16.000
          </div>

          <div className="mb-6" data-id="element-130">
            <p className="text-white/40 line-through text-lg mb-1" data-id="element-131">$43.990</p>
            <p className="text-5xl font-[900] text-mint font-['Open_Sans',_sans-serif]" data-id="element-132">
              $27.990
              <span className="text-base text-white/40 font-normal ml-2" data-id="element-133">
                ARS
              </span>
            </p>
          </div>

          <ul className="space-y-3 mb-6 flex-1" data-id="element-134">
            <li className="flex items-start gap-3 text-white/80 text-sm" data-id="element-135">
              <Check size={18} className="text-mint shrink-0 mt-0.5" data-id="element-136" />
              <span data-id="element-137">
                <strong data-id="element-138">Todo del Megapack</strong> (5 tomos + 3 bonos)
              </span>
            </li>
            <li className="border-t border-mint/10 pt-3 flex items-start gap-3 text-mint text-sm font-medium" data-id="element-139">
              <span className="text-xs uppercase tracking-wider mt-0.5" data-id="element-140">
                + Nutripro Plus
              </span>
            </li>
            <li className="flex items-start gap-3 text-white/80 text-sm" data-id="element-141">
              <Check size={18} className="text-mint shrink-0 mt-0.5" data-id="element-142" />
              <span data-id="element-143">Sistema para aumentar honorarios</span>
            </li>
            <li className="flex items-start gap-3 text-white/80 text-sm" data-id="element-144">
              <Check size={18} className="text-mint shrink-0 mt-0.5" data-id="element-145" />
              <span data-id="element-146">Marketing y captación de pacientes</span>
            </li>
            <li className="flex items-start gap-3 text-white/80 text-sm" data-id="element-147">
              <Check size={18} className="text-mint shrink-0 mt-0.5" data-id="element-148" />
              <span data-id="element-149">Gestión de precios y cobro profesional</span>
            </li>
            <li className="flex items-start gap-3 text-white/80 text-sm" data-id="element-150">
              <Check size={18} className="text-mint shrink-0 mt-0.5" data-id="element-151" />
              <span data-id="element-152">Estrategias de negocio y fidelización</span>
            </li>
          </ul>
        </FadeIn>
      </div>

      {/* Main CTA */}
      <FadeIn delay={0.3} className="text-center mb-6" data-id="element-153">
        <motion.a href="https://salud-en-tu-plato.myshopify.com/checkouts/cn/hWNAwU2fxxoZKry1E28dbN7i/es-ar?_r=AQABUz-DDfQSB1cPsEXTz0QcvPazglRT5B40d_lxn2LWtqI&cart_link_id=psdRzX2L&preview_theme_id=151828791463" target="_blank" rel="noopener noreferrer" whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} className="block w-full max-w-2xl mx-auto bg-gradient-to-r from-mint to-emerald-400 hover:from-mint/90 hover:to-emerald-400/90 text-black font-[900] text-lg md:text-xl py-5 px-8 rounded-2xl shadow-xl shadow-mint/20 transition-all font-['Open_Sans',_sans-serif] text-center" data-id="element-154">
          SÍ, QUIERO EL MEGAPACK + NUTRIPRO PLUS
        </motion.a>
        <p className="text-white/50 text-sm mt-4 italic" data-id="element-155">
          La más elegida por nutris que quieren profesionalizarse y cobrar lo
          que merecen
        </p>
      </FadeIn>

      {/* Trust Bar */}
      <FadeIn delay={0.4} className="mb-12" data-id="element-156">
        <div className="flex flex-wrap justify-center gap-6 md:gap-10 bg-surface border border-mint/10 rounded-2xl py-5 px-6 max-w-3xl mx-auto" data-id="element-157">
          <div className="flex items-center gap-2 text-white/60 text-sm font-medium" data-id="element-158">
            <Lock size={16} className="text-mint" data-id="element-159" />
            Pago seguro
          </div>
          <div className="flex items-center gap-2 text-white/60 text-sm font-medium" data-id="element-160">
            <Zap size={16} className="text-mint" data-id="element-161" />
            Acceso en 5 min
          </div>
          <div className="flex items-center gap-2 text-white/60 text-sm font-medium" data-id="element-162">
            <ShieldCheck size={16} className="text-mint" data-id="element-163" />
            Garantía 7 días
          </div>
          <div className="flex items-center gap-2 text-white/60 text-sm font-medium" data-id="element-164">
            <CreditCard size={16} className="text-mint" data-id="element-165" />
            Mercado Pago
          </div>
        </div>
      </FadeIn>

      {/* Comparison Block */}
      <FadeIn delay={0.5} className="mb-12" data-id="element-166">
        <h3 className="text-2xl font-bold text-center text-white mb-6" data-id="element-167">
          Sin Plus vs Con Plus
        </h3>
        <div className="bg-surface border border-mint/10 rounded-2xl overflow-hidden" data-id="element-168">
          <div className="grid grid-cols-3 bg-white/5 p-4 border-b border-mint/10 font-bold text-sm md:text-base" data-id="element-169">
            <div className="text-white/60" data-id="element-170">Área</div>
            <div className="text-white/80 text-center" data-id="element-171">Estándar</div>
            <div className="text-mint text-center" data-id="element-172">Plus</div>
          </div>

          {[{
          area: 'Imagen',
          std: 'Clínica sólida',
          plus: 'Marca profesional'
        }, {
          area: 'Precios',
          std: 'Lo que cobrás hoy',
          plus: 'Sistema para aumentar honorarios'
        }, {
          area: 'Cobro',
          std: 'Gestión manual',
          plus: 'Scripts y políticas de cobro'
        }, {
          area: 'Retención',
          std: 'Depende del paciente',
          plus: 'Estrategias de fidelización'
        }, {
          area: 'Organización',
          std: 'Orden básico',
          plus: 'Automatización y flujos'
        }, {
          area: 'Marketing',
          std: 'No incluye',
          plus: 'Plan de captación 12 meses'
        }].map((row, i) => <div key={i} className="grid grid-cols-3 p-4 border-b border-mint/5 text-sm md:text-base items-center" data-id="element-173">
              <div className="font-medium text-white/70" data-id="element-174">{row.area}</div>
              <div className="text-center text-white/60" data-id="element-175">{row.std}</div>
              <div className="text-center text-mint font-medium flex items-center justify-center gap-2" data-id="element-176">
                <Check size={16} className="hidden md:block" data-id="element-177" /> {row.plus}
              </div>
            </div>)}
        </div>
      </FadeIn>

      {/* Objections */}
      <FadeIn delay={0.6} className="mb-12" data-id="element-178">
        <div className="grid md:grid-cols-3 gap-6" data-id="element-179">
          <div className="bg-surface border border-mint/10 p-6 rounded-2xl" data-id="element-180">
            <h4 className="font-bold text-mint mb-2" data-id="element-181">
              ¿Y si soy recién recibido?
            </h4>
            <p className="text-white/70 text-sm" data-id="element-182">
              Te da la estructura y seguridad que la facultad no te dio para tu
              primera consulta. Entrás con ventaja.
            </p>
          </div>
          <div className="bg-surface border border-mint/10 p-6 rounded-2xl" data-id="element-183">
            <h4 className="font-bold text-mint mb-2" data-id="element-184">
              ¿Y si ya tengo experiencia?
            </h4>
            <p className="text-white/70 text-sm" data-id="element-185">
              Te ahorra horas de armado de material y te da un sistema pulido
              para escalar sin quemarte la cabeza.
            </p>
          </div>
          <div className="bg-surface border border-mint/10 p-6 rounded-2xl" data-id="element-186">
            <h4 className="font-bold text-mint mb-2" data-id="element-187">¿Y si no me sirve?</h4>
            <p className="text-white/70 text-sm" data-id="element-188">
              Tenés 7 días de garantía total. Si sentís que no te suma valor, te
              devolvemos el dinero sin hacer preguntas.
            </p>
          </div>
        </div>
      </FadeIn>

      {/* Closing */}
      <FadeIn delay={0.7} className="text-center max-w-3xl mx-auto" data-id="element-189">
        <h3 className="text-3xl md:text-4xl font-display font-bold text-white mb-4" data-id="element-190">
          Dejá de perder domingos armando planes.
        </h3>
        <p className="text-xl text-mint/80 mb-8" data-id="element-191">
          Llevate el sistema que funciona y recuperá tu tiempo.
        </p>
        <button onClick={() => window.scrollTo({
        top: document.getElementById('comprar')?.offsetTop,
        behavior: 'smooth'
      })} className="inline-flex items-center justify-center gap-2 bg-mint hover:bg-mint/80 text-black font-bold text-lg py-5 px-10 rounded-xl shadow-xl shadow-mint/10 transition-all hover:scale-105" data-id="element-192">
          ELEGIR MI OPCIÓN AHORA <ArrowRight size={20} data-id="element-193" />
        </button>
      </FadeIn>
    </section>;
}